import React from "react";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import { cleanDate } from "../../../../util/app";

const ShortTermServiceAssessmentList = ({ items, onView, onConfirm }) => {
    const tHeads = [
        { title: "SN", width: "5%" },
        { title: "Current Presentation", width: "40%" },
        { title: "Staff", width: "20%" },
        {
            title: "Date & Time",
            width: "15%",
        },
        {
            title: "Status",
            width: "10%",
        },
        {
            title: "Actions",
            width: "10%",
        },
    ];
    if (items.length)
        return (
            <>
                <table className="table table-bordered">
                    <thead>
                        {tHeads.map((item) => (
                            <th style={{ width: item.width }} key={item.title}>
                                {item.title}
                            </th>
                        ))}
                    </thead>
                    <tbody>
                        {items.map((item, idx) => (
                            <tr key={item.id}>
                                <td>
                                    <strong>{idx + 1}</strong>
                                </td>
                                <td>{item.presenting_problem}</td>
                                <td>
                                    <StaffProfileCard item={item.author} />
                                </td>
                                <td>{cleanDate(item.created_at)}</td>
                                <td>{item.confirm.status ? <span className="badge badge-success">Confirmed</span> : <span className="badge badge-warning">UnConfirm</span>}</td>
                                <td>
                                    <button onClick={() => onView(item)} title="View" className="mdl-button mdl-button--icon mdl-button--colored btn-default">
                                        <i className="material-icons text-primary">arrow_right_alt</i>
                                    </button>
                                    {!item.confirm.status && (
                                        <button onClick={() => onConfirm(item)} title="Confirm" className="mdl-button mdl-button--icon mdl-button--colored btn-default ml-2">
                                            <i className="material-icons text-success">check_circle</i>
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
        );
    return (
        <div className="text-center mt-5">
            <h4 className="text-pink">No Record Found!</h4>
            <p>No Short Term Service Assessment has been created for this patient.</p>
        </div>
    );
};

export default ShortTermServiceAssessmentList;
